export default __webpack_public_path__ + "static/media/bg_login.1fcc7cd7.png";